import { Pipe as NgPipe } from '@angular/core';

/**
 * Reverses the provided string.
 */
@NgPipe({
  name: 'reverse'
})
export class ReversePipe {
  /**
   * Reverses the provided string.
   *
   * @param value Value to be reversed
   */
  public transform(value: any): any {
    return value.slice().reverse();
  }
}
